import { ErrorMessage, Field, Form, Formik, useFormik } from "formik";
import React, { useState, useEffect, useContext, useMemo, useRef, Fragment } from "react";
import * as Yup from "yup";
import CommonInputField from "../../components/common/CommonInputField";
import CommonRadio from "../../components/common/CommonRadio";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import AppContext from "../../context/AppContext";
import {
  fetchOrganizations,
  createUser,
  getUserInfoAPI,
  updateUser,
  getAllByOrganization,
  getAllByOrganizationId,
  getActivityListByProjectId,
  getProjectListByDepartmentId,
  getMultipleProject,
  getMultipleActivity,
  projectsForClockIn,
} from "../../service/User";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import translations from "../../components/common/Translations";
import CommonCheckbox from "../../components/common/task/CommonCheckbox";
import CommonButton from "../../components/common/CommonButton";
import uploadImage from "../../assets/uploadImage.png"
import ReactSelector from "../../components/common/CommonReactSelector";
import { Spinner } from "../../Spinner";
import { Dialog, Transition } from "@headlessui/react";
import { RxCross2 } from "react-icons/rx";
import { getOrganizationById } from "../../service/Report";
import { FaEye, FaEyeSlash } from "react-icons/fa6";
import { fetchData } from "../../service/workflow";
const AddUser = () => {
  const { userId } = useParams();
  const fileInputRef = useRef(null);
  const [organizations, setOrganizations] = useState([]);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isOfficeUser, setOfficeUser] = useState(false)
  const [initialUserInfo, setInitialUserInfo] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  const { theme, langMode, profilePic } = useContext(AppContext);
  const navigate = useNavigate();
  const [phoneError, setPhoneError] = useState("");
  const [isPasswordCleared, setIsPasswordCleared] = useState(false);
  const [uploadedImg, setUploadedImg] = useState('')
  const [selectedFile, setSelectedFile] = useState('')
  const [organization, setOrganization] = useState([])
  const [department, setDepartment] = useState([])
  const [project, setProject] = useState([])
  const [workflowList, setWorkflowList] = useState([])
  const [clockIn, setClockIn] = useState([])
  const [isShowPrivileges, setIsShowPrivileges] = useState(false)
  const [showPassword, setShowPassword] = useState(false);
  const [isClock, setIsClock] = useState(false)
  const [isLoader, setLoader]= useState(false)
  // Initialize state with all privileges set to true

  const privileges = [
    // { label: translations[langMode].addeditActivity, key: "canAddEditActivityTemplates" },
    // { label: translations[langMode].addnewlabel, key: "canAddLabelsToActivityTemplates" },
    // { label: translations[langMode].modifyguidline, key: "canModifyGuidelines" },
    { label: translations[langMode].createDashboar, key: "canCreateDashboard" },
    { label: translations[langMode].support, key: "canAccessCustomerSupport" },
    { label: translations[langMode].canasset, key: "canAccessAssetManagement" },
    { label: "Settings", key: "canAccessSettings" },
    { label: "Configuration", key: "canAccessConfiguration" },
    { label: "TaskManager", key: "canAccessTaskManager" },
    { label: "Account History", key: "canAccessAccountHistory" },
    { label: "Workflow", key: "canAccessWorkflow" },
    { label: "Worklog", key: "canAccessWorklog" },
    { label: "stock-management", key: "canAccessStockManagement" },
    { label: "Reports", key: "canAccessReports" },
    { label: "Security", key: "canAccessSecurity" },
    { label: translations[langMode].addEdituser, key: "canAddEditUser" },
  ]

  const [privilegeStatus, setPrivilegeStatus] = useState(
    privileges.reduce((acc, curr) => {
      acc[curr.key] = false; // Default status
      return acc;
    }, {})
  );

  const [userVisibility, setUserVisibility] = useState([])
  const [initialValues, setInitialValues] = useState({
    name: "",
    userType: "",
    email: "",
    password: "",
    phone: "",
    areaCode: "",
    organization: "",
    departmentList: [],
    projectList: "",
    workflowList: [null],
    canAddEditActivityTemplates: false,
    canAddEditLeaderboard: false,
    canCreateDashboard: false,
    canModifyGuidelines: false,
    canAddEditUser: false,
    canAddLabelsToActivityTemplates: false,
    canAccessAssetManagement: false,
    canAddEditInventory: false,
    canAddEditProtectedAccount: false,
    canTaskManage: false,
    canAccessCustomerSupport: false,
    canAccessSettings: false,
    canAccessConfiguration: false,
    canAccessTaskManager: false,
    canAccessAccountHistory: false,
    canAccessWorkflow: false,
    canAccessWorklog: false,
    canAccessStockManagement: false,
    canAccessReports: false,
    canAccessSecurity: false,
    projectIdForClockInClockOut: null
    // userVisibility: [],

  });
  const [countryDetail, setCountryDetail] = useState([
    { name: "Afghanistan", length: 9, countryCode: "+93" },
    { name: "Albania", length: 8, countryCode: "+355" },
    { name: "Algeria", length: 9, countryCode: "+213" },
    { name: "Andorra", length: 6, countryCode: "+376" },
    { name: "Angola", length: 9, countryCode: "+244" },
    { name: "Argentina", length: 10, countryCode: "+54" },
    { name: "Armenia", length: 8, countryCode: "+374" },
    { name: "Aruba", length: 7, countryCode: "+297" },
    { name: "Australia", length: 9, countryCode: "+61" },
    { name: "Austria", length: 12, countryCode: "+43" },
    { name: "Azerbaijan", length: 9, countryCode: "+994" },
    { name: "Antigua and Barbuda", length: 7, countryCode: "+1268" },
    { name: "Bahamas", length: 7, countryCode: "+1 242" },
    { name: "Bahrain", length: 8, countryCode: "+973" },
    { name: "Bangladesh", length: 10, countryCode: "+880" },
    { name: "Barbados", length: 10, countryCode: "+1 246" },
    { name: "Belarus", length: 9, countryCode: "+375" },
    { name: "Belgium", length: 9, countryCode: "+32" },
    { name: "Belize", length: 7, countryCode: "+501" },
    { name: "Benin", length: 8, countryCode: "+229" },
    { name: "Bhutan", length: 8, countryCode: "+975" },
    { name: "Bolivia", length: 8, countryCode: "+591" },
    { name: "Bosnia and Herzegovina", length: 8, countryCode: "+387" },
    { name: "Botswana", length: 7, countryCode: "+267" },
    { name: "Brazil", length: 10, countryCode: "+55" },
    { name: "Brunei", length: 7, countryCode: "+673" },
    { name: "Bulgaria", length: 8, countryCode: "+359" },
    { name: "Burkina Faso", length: 10, countryCode: "+226" },
    { name: "Burundi", length: 8, countryCode: "+257" },
    { name: "British Indian Ocean Territiry", length: 7, countryCode: "+246" },
    { name: "Cabo Verde", length: 7, countryCode: "+238" },
    { name: "Cambodia", length: 9, countryCode: "+855" },
    { name: "Cameroon", length: 9, countryCode: "+237" },
    { name: "Canada", length: 11, countryCode: "+1" },
    { name: "Central African Republic", length: 10, countryCode: "+236" },
    { name: "Chad", length: 8, countryCode: "+235" },
    { name: "Chile", length: 9, countryCode: "+56" },
    { name: "China", length: 11, countryCode: "+86" },
    { name: "Colombia", length: 10, countryCode: "+57" },
    { name: "Comoros", length: 7, countryCode: "+269" },
    { name: "Congo (Congo-Brazzaville)", length: 10, countryCode: "+242" },
    { name: "Costa Rica", length: 8, countryCode: "+506" },
    { name: "Croatia", length: 9, countryCode: "+385" },
    { name: "Cuba", length: 8, countryCode: "+53" },
    { name: "Cyprus", length: 8, countryCode: "+357" },
    { name: "Czech Republic", length: 9, countryCode: "+420" },
    { name: "Denmark", length: 8, countryCode: "+45" },
    { name: "Djibouti", length: 7, countryCode: "+253" },
    { name: "Dominica", length: 10, countryCode: "+1 767" },
    { name: "Dominican Republic", length: 10, countryCode: "+1 809" },
    { name: "Ecuador", length: 9, countryCode: "+593" },
    { name: "Egypt", length: 10, countryCode: "+20" },
    { name: "El Salvador", length: 8, countryCode: "+503" },
    { name: "Equatorial Guinea", length: 9, countryCode: "+240" },
    { name: "Eritrea", length: 8, countryCode: "+291" },
    { name: "Estonia", length: 7, countryCode: "+372" },
    { name: "Eswatini", length: 8, countryCode: "+268" },
    { name: "Ethiopia", length: 9, countryCode: "+251" },
    { name: "Fiji", length: 7, countryCode: "+679" },
    { name: "Finland", length: 12, countryCode: "+358" },
    { name: "France", length: 9, countryCode: "+33" },
    { name: "Gabon", length: 8, countryCode: "+241" },
    { name: "Gambia", length: 7, countryCode: "+220" },
    { name: "Georgia", length: 9, countryCode: "+995" },
    { name: "Germany", length: 11, countryCode: "+49" },
    { name: "Ghana", length: 9, countryCode: "+233" },
    { name: "Greece", length: 10, countryCode: "+30" },
    { name: "Grenada", length: 10, countryCode: "+1 473" },
    { name: "Guatemala", length: 8, countryCode: "+502" },
    { name: "Guinea", length: 9, countryCode: "+224" },
    { name: "Guinea-Bissau", length: 7, countryCode: "+245" },
    { name: "Guyana", length: 10, countryCode: "+592" },
    { name: "Haiti", length: 8, countryCode: "+509" },
    { name: "Honduras", length: 8, countryCode: "+504" },
    { name: "Hungary", length: 9, countryCode: "+36" },
    { name: "Iceland", length: 7, countryCode: "+354" },
    { name: "India", length: 10, countryCode: "+91" },
    { name: "Indonesia", length: 10, countryCode: "+62" },
    { name: "Iran", length: 10, countryCode: "+98" },
    { name: "Iraq", length: 10, countryCode: "+964" },
    { name: "Ireland", length: 7, countryCode: "+353" },
    { name: "Israel", length: 9, countryCode: "+972" },
    { name: "Italy", length: 10, countryCode: "+39" },
    { name: "Jamaica", length: 10, countryCode: "+1 876" },
    { name: "Japan", length: 10, countryCode: "+81" },
    { name: "Jordan", length: 9, countryCode: "+962" },
    { name: "Kazakhstan", length: 10, countryCode: "+7" },
    { name: "Kenya", length: 10, countryCode: "+254" },
    { name: "Kiribati", length: 7, countryCode: "+686" },
    { name: "Kuwait", length: 8, countryCode: "+965" },
    { name: "Kyrgyzstan", length: 9, countryCode: "+996" },
    { name: "Laos", length: 8, countryCode: "+856" },
    { name: "Latvia", length: 8, countryCode: "+371" },
    { name: "Lebanon", length: 8, countryCode: "+961" },
    { name: "Lesotho", length: 8, countryCode: "+266" },
    { name: "Liberia", length: 7, countryCode: "+231" },
    { name: "Libya", length: 9, countryCode: "+218" },
    { name: "Liechtenstein", length: 10, countryCode: "+423" },
    { name: "Lithuania", length: 9, countryCode: "+370" },
    { name: "Luxembourg", length: 9, countryCode: "+352" },
    { name: "Madagascar", length: 9, countryCode: "+261" },
    { name: "Malawi", length: 10, countryCode: "+265" },
    { name: "Malaysia", length: 10, countryCode: "+60" },
    { name: "Maldives", length: 7, countryCode: "+960" },
    { name: "Mali", length: 8, countryCode: "+223" },
    { name: "Malta", length: 8, countryCode: "+356" },
    { name: "Marshall Islands", length: 7, countryCode: "+692" },
    { name: "Mauritania", length: 8, countryCode: "+222" },
    { name: "Mauritius", length: 10, countryCode: "+230" },
    { name: "Mexico", length: 10, countryCode: "+52" },
    { name: "Micronesia", length: 7, countryCode: "+691" },
    { name: "Moldova", length: 8, countryCode: "+373" },
    { name: "Monaco", length: 8, countryCode: "+377" },
    { name: "Mongolia", length: 8, countryCode: "+976" },
    { name: "Montenegro", length: 8, countryCode: "+382" },
    { name: "Morocco", length: 10, countryCode: "+212" },
    { name: "Mozambique", length: 9, countryCode: "+258" },
    { name: "Myanmar (formerly Burma)", length: 9, countryCode: "+95" },
    { name: "Namibia", length: 9, countryCode: "+264" },
    { name: "Nauru", length: 7, countryCode: "+674" },
    { name: "Nepal", length: 10, countryCode: "+977" },
    { name: "Netherlands", length: 10, countryCode: "+31" },
    { name: "New Zealand", length: 9, countryCode: "+64" },
    { name: "Nicaragua", length: 8, countryCode: "+505" },
    { name: "Niger", length: 8, countryCode: "+227" },
    { name: "Nigeria", length: 10, countryCode: "+234" },
    { name: "North Korea", length: 9, countryCode: "+850" },
    { name: "North Macedonia", length: 8, countryCode: "+389" },
    { name: "Norway", length: 8, countryCode: "+47" },
    { name: "Oman", length: 8, countryCode: "+968" },
    { name: "Pakistan", length: 10, countryCode: "+92" },
    { name: "Palau", length: 7, countryCode: "+680" },
    { name: "Palestine", length: 10, countryCode: "+970" },
    { name: "Panama", length: 7, countryCode: "+507" },
    { name: "Papua New Guinea", length: 10, countryCode: "+675" },
    { name: "Paraguay", length: 9, countryCode: "+595" },
    { name: "Peru", length: 9, countryCode: "+51" },
    { name: "Philippines", length: 10, countryCode: "+63" },
    { name: "Poland", length: 9, countryCode: "+48" },
    { name: "Portugal", length: 9, countryCode: "+351" },
    { name: "Qatar", length: 8, countryCode: "+974" },
    { name: "Romania", length: 10, countryCode: "+40" },
    { name: "Russia", length: 10, countryCode: "+7" },
    { name: "Rwanda", length: 10, countryCode: "+250" },
    { name: "Saint Kitts and Nevis", length: 10, countryCode: "+1 869" },
    { name: "Saint Lucia", length: 10, countryCode: "+1 758" },
    {
      name: "Saint Vincent and the Grenadines",
      length: 10,
      countryCode: "+1 784",
    },
    { name: "Samoa", length: 7, countryCode: "+685" },
    { name: "San Marino", length: 10, countryCode: "+378" },
    { name: "Sao Tome and Principe", length: 7, countryCode: "+239" },
    { name: "Saudi Arabia", length: 9, countryCode: "+966" },
    { name: "Senegal", length: 9, countryCode: "+221" },
    { name: "Serbia", length: 8, countryCode: "+381" },
    { name: "Seychelles", length: 7, countryCode: "+248" },
    { name: "Sierra Leone", length: 8, countryCode: "+232" },
    { name: "Singapore", length: 8, countryCode: "+65" },
    { name: "Slovakia", length: 9, countryCode: "+421" },
    { name: "Slovenia", length: 8, countryCode: "+386" },
    { name: "Solomon Islands", length: 7, countryCode: "+677" },
    { name: "Somalia", length: 8, countryCode: "+252" },
    { name: "South Africa", length: 10, countryCode: "+27" },
    { name: "South Korea", length: 10, countryCode: "+82" },
    { name: "South Sudan", length: 9, countryCode: "+211" },
    { name: "Spain", length: 9, countryCode: "+34" },
    { name: "Sri Lanka", length: 10, countryCode: "+94" },
    { name: "Sudan", length: 9, countryCode: "+249" },
    { name: "Suriname", length: 7, countryCode: "+597" },
    { name: "Sweden", length: 10, countryCode: "+46" },
    { name: "Switzerland", length: 9, countryCode: "+41" },
    { name: "Syria", length: 9, countryCode: "+963" },
    { name: "Taiwan", length: 9, countryCode: "+886" },
    { name: "Tajikistan", length: 9, countryCode: "+992" },
    { name: "Tanzania", length: 10, countryCode: "+255" },
    { name: "Thailand", length: 9, countryCode: "+66" },
    { name: "Timor-Leste", length: 9, countryCode: "+670" },
    { name: "Togo", length: 8, countryCode: "+228" },
    { name: "Tonga", length: 7, countryCode: "+676" },
    { name: "Trinidad and Tobago", length: 10, countryCode: "+1 868" },
    { name: "Tunisia", length: 8, countryCode: "+216" },
    { name: "Turkey", length: 10, countryCode: "+90" },
    { name: "Turkmenistan", length: 8, countryCode: "+993" },
    { name: "Tuvalu", length: 7, countryCode: "+688" },
    { name: "Uganda", length: 10, countryCode: "+256" },
    { name: "Ukraine", length: 9, countryCode: "+380" },
    { name: "United Arab Emirates", length: 9, countryCode: "+971" },
    { name: "United Kingdom", length: 10, countryCode: "+44" },
    { name: "United States", length: 10, countryCode: "+1" },
    { name: "Uruguay", length: 8, countryCode: "+598" },
    { name: "Uzbekistan", length: 9, countryCode: "+998" },
    { name: "Vanuatu", length: 7, countryCode: "+678" },
    { name: "Vatican City", length: 10, countryCode: "+379" },
    { name: "Venezuela", length: 10, countryCode: "+58" },
    { name: "Vietnam", length: 10, countryCode: "+84" },
    { name: "Yemen", length: 9, countryCode: "+967" },
    { name: "Zambia", length: 10, countryCode: "+260" },
    { name: "Zimbabwe", length: 9, countryCode: "+263" },
  ]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isEdit = queryParams.get("isEdit") === "true";
  const [selectedUserType, setSelectedUserType] = useState("");
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("User Name is required"),
    userType: Yup.string().required("User Type is required"),
    // email: Yup.string().email("Invalid email").required("Email is required"),
    password: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(/\d/, "Password must contain at least one number")
      .matches(
        /[!@#$%^&*(),.?":{}|<>]/,
        "Password must contain at least one special character"
      )

  });

  const GetUserInfo = () => {
    getUserInfoAPI(userId)
      .then((response) => {
        const user = response.data.body.value;
        setUserInfo(user);
        setInitialUserInfo(user);
        setInitialValues({
          name: user.name || "",
          userType: user.userType || "",
          email: user.email || "",
          phone: user?.phone?.replace(/\D/g, "")?.startsWith("968")
            ? `${user?.phone?.replace(/\D/g, "")?.slice(3, 7)} ${user?.phone?.replace(/\D/g, "")?.slice(7, 11)}`
            : "",
          areaCode: user.areaCode || "",
          workflowList: user.workflowList || [],
          userStatus: user.userStatus || false,
          organization: user.organization.organizationId || "",
          canAddEditActivityTemplates: user.canAddEditActivityTemplates,
          canAddEditLeaderboard: user.canAddEditLeaderboard,
          canCreateDashboard: user.canCreateDashboard,
          canModifyGuidelines: user.canModifyGuidelines,
          canAddEditUser: user.canAddEditUser,
          canAccessCustomerSupport: user.canAccessCustomerSupport,
          // canAddEditInventory: String(user.canAddEditInventory),
          // canAddEditProtectedAccount: String(user.canAddEditProtectedAccount),
          // canTaskManage: String(user.canTaskManage),
          canAddLabelsToActivityTemplates:
            user.canAddLabelsToActivityTemplates
          ,
          canAccessAssetManagement: user.canAccessAssetManagement,
          password: user.password,
          departmentList: user.departmentList || [],
          projectList: user.projectList || [],
          projectIdForClockInClockOut: user?.projectIdForClockInClockOut || null
        });
        // Update privilegeStatus based on user data
        setPrivilegeStatus((prevStatus) => {
          const updatedStatus = { ...prevStatus };
          privileges.forEach((privilege) => {
            updatedStatus[privilege.key] = user[privilege.key] || false;
          });
          return updatedStatus;
        });

        // clock in
        setIsClock(user?.clockInEnabled)

        // Set userVisibility state with API data
        setUserVisibility(!user.userVisibility.includes(null) ? user.userVisibility : []);
      })
      .catch((error) => {
        console.error("An error occurred:", error);
      });
  };

  useEffect(() => {
    if (userId) {
      GetUserInfo();
    }
  }, [userId]);

  const validatePassword = (password) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return regex.test(password);
  };


  const userDetails = JSON.parse(localStorage.getItem("userDetails"))
  console.log('userDetails: ', userDetails);

  const fetchOrganizationsData = async () => {
    const token = Cookies.get("accessToken");
    try {
      let orgs;
      if (userDetails.userType === "super_admin") {
        orgs = await fetchOrganizations();
      } else {
        const fetchedOrg = await getOrganizationById(userDetails?.organization?.organizationId);
        orgs = Array.isArray(fetchedOrg) ? fetchedOrg : [fetchedOrg];
      }
      setOrganizations(orgs);
    } catch (error) { }
  };

  useEffect(() => {
    fetchOrganizationsData();
  }, []);

  useEffect(() => {
    const userType = Cookies.get("userType");
    setIsSuperAdmin(userType === "super_admin");
    setIsAdmin(userType === "admin");
    setOfficeUser(userType === 'office_user')
  });

  console.log("Selected User Type:", selectedUserType);
  console.log("isSuperAdmin:", isSuperAdmin);
  console.log("isAdmin:", isAdmin);
  console.log("isOfficeUser:", isOfficeUser);


  const handleGoBack = () => {
    navigate("/all-users");
  };

  const validatePhoneNumber = (phone) => {
    let numericPhone = phone?.replace(/[^0-9]/g, "");
    const defaultCountry = { name: "Oman", length: 8, countryCode: "968" };

    let country = countryDetail.find((c) =>
      numericPhone.startsWith(c.countryCode.replace(/[^0-9]/g, ""))
    );

    if (!country) {
      country = defaultCountry;
      numericPhone = defaultCountry.countryCode + numericPhone;
    }

    // Special Handling for US & Canada
    if (country.countryCode === "+1") {
      if (countryDetail.name === "United States" && numericPhone.length !== 11) {
        setPhoneError("United States phone numbers should be exactly 10 digits long.");
        return false;
      } else if (countryDetail.name === "Canada" && numericPhone.length !== 12) {
        setPhoneError("Canada phone numbers should be exactly 11 digits long.");
        return false;
      }
    } else {
      const phoneNumberLength =
        numericPhone.length - country.countryCode.replace(/[^0-9]/g, "").length;

      if (phoneNumberLength !== country.length) {
        setPhoneError(`${country.name} phone numbers should be exactly ${country.length} digits long.`);
        return false;
      }
    }

    setPhoneError("");
    return true;
  };

  const shouldDisablePassword = useMemo(() => {
    if (!isEdit) return false; // If not in edit mode, password field should be enabled.

    // Define role-based conditions
    if (isSuperAdmin) {
      return false; // Super Admin can edit for everyone.
    }

    if (isAdmin) {
      return !(selectedUserType === "field_agent" || selectedUserType === "office_user");
    }

    if (isOfficeUser) {
      return !(selectedUserType === "field_agent");
    }

    return true; // Default case, disable if conditions don't match.
  }, [isEdit, isSuperAdmin, isAdmin, isOfficeUser, selectedUserType]); // Dependencies ensure correct re-evaluation

  const formatOmanPhoneNumber = (phone) => {
    // Remove all non-numeric characters
    const numericOnly = phone.replace(/\D/g, '');

    // Check if it's an Oman number (starting with 968)
    if (numericOnly.startsWith('968')) {
      // Format as +968 xxxx xxxx
      const countryCode = numericOnly.slice(0, 3);
      const firstPart = numericOnly.slice(3, 7);
      const secondPart = numericOnly.slice(7, 11);

      // Only format if we have enough digits
      if (numericOnly.length >= 7) {
        return `+${countryCode} ${firstPart}${secondPart ? ` ${secondPart}` : ''}`;
      }
    }

    return phone; // Return original format for other countries
  };

  const formatPhoneNumber = (value) => {
    const cleaned = value.replace(/\D/g, "").slice(0, 8);
    const match = cleaned.match(/^(\d{0,4})(\d{0,4})$/);
    if (!match) return "";

    const [, part1, part2] = match;
    return `${part1}${part2 ? " " + part2 : ""}`;
  };


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      console.log("button click", values)
      if (!values.password) {
        toast.error('Password is Required');
        return;
      }
      // if (!validatePassword(values.password)) {
      //   toast.error("Password must be at least 8 characters, include an uppercase letter, lowercase letter, number, and special character.");
      //   return
      // }
      const token = Cookies.get("accessToken");
      if (!token) {
        toast.error("Token is not present");
        return;
      }
      // const isPhoneValid = validatePhoneNumber(values.phone);
      // if (!isPhoneValid) {
      //   toast.error("Invalid phone number. Please check and try again.");
      //   return;
      // }
      try {
        let response;
        setLoader(true)
        if (userId) {
          response = await updateUser(
            {
              userId: Number(userId),
              ...values,
              projectIdForClockInClockOut: isClock ? values?.projectIdForClockInClockOut : null,
              phone: `+968 ${values?.phone}`,
              workflowList: values?.userType === "field_agent" ? values?.workflowList : null,
              ...privilegeStatus,
              userVisibility: userVisibility,
              passwordChanged: isPasswordCleared,
              organization: { organizationId: values.organization },
              ...values?.userType === "field_agent" && { clockInEnabled: isClock }
            },
            token
          );
        } else {
          response = await createUser(
            {
              ...values,
              projectIdForClockInClockOut: isClock ? values?.projectIdForClockInClockOut : null,
              phone: `+968 ${values?.phone}`,
              workflowList: values?.userType === "field_agent" ? values?.workflowList : null,
              ...privilegeStatus,
              userVisibility: userVisibility,
              organization: { organizationId: values.organization },
              ...values?.userType === "field_agent" && { clockInEnabled: isClock }
            },
            token
          );
        }
        setLoader(false)
        if (response.header.code === 600) {
          if (userId) {
            toast.success("User updated successfully");
            navigate("/all-users");
          } else {
            toast.success("User created successfully");
            navigate("/all-users");
            resetForm();
            setInitialValues((prev) => ({ ...prev, userVisibility: [] }));
          }
        } else if (response.header.code === 650) {
          toast.error("Server Error");
        } else if (response.header.code === 612) {
          toast.error(response.body.value);
        } else {
          toast.error(response.body.value);
        }
      } catch (error) {
        setLoader(false)
        console.error("Error handling user:", error);
        toast.error("Failed to handle user");
      } finally {
        setLoader(false)
        setSubmitting(false);
      }
    },
  });

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    const allowedTypes = ["image/jpeg", "image/png", "image/gif"];

    if (!file || !allowedTypes.includes(file.type)) {
      toast.error("Invalid file type. Please upload a JPG, PNG, or GIF.");
      return;
    }
    setUploadedImg(URL.createObjectURL(file));
    setSelectedFile(file); // Store file for later upload
  };


  // Get all organizations list
  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        let data;
        if (userDetails?.userType === "super_admin") {
          data = await getAllByOrganization();
        } else {
          const fetchedOrg = await getOrganizationById(userDetails?.organization?.organizationId);
          data = Array.isArray(fetchedOrg) ? fetchedOrg : [fetchedOrg];
        }
        setInitialValues((prevValues) => ({
          ...prevValues,
          // organization: data?.find(i => i)?.organizationId || "", // Ensure a fallback in case of undefined
        }));
        setOrganization(data);
      } catch (error) {
        console.error("Error fetching organizations:", error);
      }
    };

    fetchOrganizations();
  }, []);

  // Get all organizations list by ID when userInfo.organization changes
  useEffect(() => {
    const fetchDepartments = async () => {
      if (!formik?.values?.organization) return; // Don't fetch if there's no organization selected
      try {
        const data = await getAllByOrganizationId(formik?.values?.organization);
        setDepartment(data);
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    };

    fetchDepartments(); // Trigger the department fetch whenever `userInfo.organization` changes
  }, [formik?.values?.organization]);


  // get project list by department id
  useEffect(() => {
    const fetchProjectList = async () => {
      if (!formik?.values?.departmentList?.length > 0) return; // Don't fetch if there's no organization selected

      try {
        const data = await getMultipleProject(formik?.values?.departmentList.includes("all") ? (department || [])?.map(i => i?.id) : formik?.values?.departmentList);
        setProject(data)
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    };

    fetchProjectList(); // Trigger the department fetch whenever `userInfo.organization` changes
  }, [formik?.values?.departmentList]);

  // get activity list by project id
  useEffect(() => {
    const fetchActivityList = async () => {
      // if (!formik?.values?.projectList?.length > 0) return; // Don't fetch if there's no organization selected

      try {
        const data = await getMultipleActivity(formik?.values?.projectList);
        setWorkflowList(data)

        const clockId = await projectsForClockIn(formik?.values?.projectList)
        setClockIn(clockId)
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    };
    if (formik.values.userType === "field_agent") {
      fetchActivityList(); // Trigger the project fetch whenever `userInfo.organization` changes
    }
  }, [formik?.values?.projectList]);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const userTypes = ["admin", "office_user", "field_agent"];
    const userType = userTypes.find((item) => item === formik.values.userType);
    if (userType) {
      setSelectedUserType({ value: userType, label: userType });
    }
    setTimeout(() => {
      setIsLoading(false); // Stop loading after delay
    }, 3000); // 2-second delay
  }, [formik.values.userType]);

  // organization
  const selectedOrganization = Array.isArray(organization) && (organization || [])?.length > 0 ? (organization || [])?.find((org) => org.organizationId === formik.values.organization) : {};

  const formattedOrganization = selectedOrganization
    ? { value: selectedOrganization.organizationId, label: selectedOrganization.organizationName }
    : null;

  // department
  const selectedDepartment = department?.find((org) => formik.values.departmentList?.includes(org.id));

  const formattedDepartment = selectedDepartment
    ? (department.length === formik.values.departmentList.length) ? { value: "all", label: "All" } : { value: selectedDepartment.id, label: selectedDepartment.name }
    : null;


  // Project
  const selectedProject = (Object.values(project)?.flat() || [])?.filter((org) => formik.values.projectList?.includes(org.id));

  const formattedProject = selectedProject
    ? (Object.values(project)?.flat().length === formik.values.projectList.length) ? { value: "all", label: "All" } : (selectedProject || [])?.map(item => ({ value: item.id, label: item.name }))
    : null;

  // clock in
  const selectedClockIn = clockIn?.map((item) => ({ value: item?.id, label: item.name }))
  const formattedClockIn = selectedClockIn?.find((item) => item.value === formik.values.projectIdForClockInClockOut)

  // Activity
  const selectedAllActivity = formik?.values?.workflowList.length === workflowList?.length;
  const selectedActivity = workflowList?.filter((org) => formik?.values?.workflowList.includes(org.workflowId));

  const formattedActivity =
    selectedAllActivity ? { value: "all", label: "All" } :
      selectedActivity
        ? (selectedActivity || [])?.map(item => ({ value: item.workflowId, label: item.workflowName }))
        : null;

  // privilege
  const handleCheckboxChangeValue = (key) => {
    setPrivilegeStatus((prevStatus) => ({
      ...prevStatus,
      [key]: !prevStatus[key], // Toggle the status
    }));
  };

  const handleVisibilityChange = (selectedOptions) => {
    if (selectedOptions && Array.isArray(selectedOptions)) {
      const validOptions = selectedOptions.filter(opt => opt && opt.value);

      if (validOptions.length > 0) {
        setUserVisibility((prev) => {
          const newValues = validOptions
            .map((option) => option.value)
            .filter((value) => !prev.includes(value));
          return [...prev, ...newValues];
        });
      }
    }
  };

  return (
    <>

      <div className="w-full max-h-[93vh] h-full bg-white flex flex-col gap-[38px]">
        <div className="inline-flex gap-3 mt-4 ml-[29px]">
          <h4
            className={` ${theme === "dark"
              ? "dark-mode "
              : theme === "high-contrast"
                ? "high-contrast  "
                : ""
              } text-2xl capitalize font-semibold text-[#111827]`}
          >
            {translations[langMode].addUser}
          </h4>
        </div>
        <div
          className={`w-[75%] mx-auto ${theme === "dark"
            ? "dark-mode"
            : theme === "high-contrast"
              ? "high-contrast"
              : ""
            } `}
        >
          <div className="w-full">
            <div className="flex justify-between items-end">
              <div className="mb-5">
                <span
                  className="text-base text-[#111827] font-semibold"
                >
                  <p className="">{translations[langMode].profileImage}</p>
                </span>
                <div className="relative w-[150px] h-[150px] mt-4 mb-[24px]">
                  <img
                    key={profilePic}
                    className={`w-[150px] h-[150px] p-1 rounded-full border-2 border-[#236DB4] ${theme === "dark"
                      ? "bg-white"
                      : theme === "high-contrast"
                        ? "bg-white"
                        : ""
                      }`}
                    src={uploadedImg || profilePic}
                    alt="profileimg"
                  />
                  <button
                    className="absolute bottom-2 right-2 bg-white p-1 rounded-full shadow-md border border-gray-300"
                    onClick={() => fileInputRef.current.click()}
                  >
                    <img src={uploadImage} className="w-[30px] h-[30px] text-gray-600" />
                  </button>

                </div>
                <input
                  type="file"
                  name="media"
                  onChange={handleImageUpload}
                  accept="image/jpeg, image/png, image/gif, image/jpg"
                  className="hidden"
                  ref={fileInputRef}
                />
              </div>
              {formik?.values?.userType === "field_agent" && <div className="flex gap-2 items-center">
                <input type="checkbox" checked={isClock} onClick={() => setIsClock(!isClock)} />
                Is ClockIn
              </div>}
            </div>

            <form onSubmit={formik.handleSubmit}>
              {/* {({ isSubmitting, setFieldValue, values, dirty }) => ( */}
              <React.Fragment>
                {/* <Form> */}
                <div className="">
                  <div className="grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2 grid-cols-1 gap-4 mb-[16px]">
                    <div className="flex flex-col gap-2">
                      <label className="text-sm">{translations[langMode].fullName}<span className="text-[#FF9F29]">*</span></label>
                      <input
                        type="text"
                        name="name"
                        // component={CommonInputField}
                        value={formik.values.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={`block p-3 w-full text-sm text-gray-900 bg-transparent rounded-md border-1 border-[#D1D5DB]
                    appearance-none focus:outline-none focus:ring-0 focus:border-gray-500 peer ${theme === "dark"
                            ? "dark-mode "
                            : theme === "high-contrast"
                              ? "high-contrast"
                              : ""
                          }`}
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <label className="text-sm">{translations[langMode].userEmail}<span className="text-[#FF9F29]">*</span></label>
                      <input
                        type="text"
                        name="email"
                        label={translations[langMode].Email}
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={`block p-3 w-full text-sm text-gray-900 bg-transparent rounded-md border-1 border-[#D1D5DB]
                    appearance-none focus:outline-none focus:ring-0 focus:border-gray-500 peer ${theme === "dark"
                            ? "dark-mode"
                            : theme === "high-contrast"
                              ? "high-contrast"
                              : ""
                          }`}
                      />
                    </div>
                    <div className="flex flex-col gap-2 justify-end">
                      <label className="text-sm">{translations[langMode].Phone} <span className="text-[#FF9F29]">*</span></label>
                      <div className="flex items-center rounded-[6px] w-full bg-transparent py-[5px] px-[10px] border border-[#D1D5DB] text-sm">
                        <div className="flex items-center gap-2">
                          <span>🇴🇲</span>
                          <span className="font-bold">+968</span>
                        </div>
                        <input
                          className={`block p-2 w-full text-sm text-gray-900 bg-transparent rounded-md
                            appearance-none border-0 focus:ring-0 focus:!shadow-none peer ${theme === "dark"
                              ? "dark-mode"
                              : theme === "high-contrast"
                                ? "high-contrast"
                                : ""
                            }`}
                          type="tel"
                          name="phone"
                          value={formik.values.phone}
                          onChange={(e) => {
                            const raw = e.target.value;
                            const cleaned = raw.replace(/\D/g, "");
                            const formatted = formatPhoneNumber(cleaned);
                            formik.setFieldValue("phone", formatted);
                          }}
                          placeholder="9123 4567"
                          maxLength={9}
                        />
                      </div>
                    </div>
                    {isLoading ? (
                      <Spinner /> // Loading state while waiting
                    ) : (
                      <>
                        <div className="flex flex-col gap-2">
                          <label className="text-sm">{translations[langMode].userType}<span className="text-[#FF9F29]">*</span></label>
                          <ReactSelector
                            name="userType"
                            defaultValue={selectedUserType}
                            options={["admin", "office_user", "field_agent"]
                              .filter(item => !(userDetails.userType === "admin" && item === "admin"))
                              .map(item => ({
                                value: item,
                                label: item,
                              }))}
                            onChange={(e) => {
                              const value = e.value;
                              formik.setFieldValue("userType", value);
                              setSelectedUserType(e);
                              if(value !== "field_agent"){
                                setIsClock(false)
                              }
                            }}
                          />
                        </div>
                        <div className="flex flex-col gap-2">
                          <label className="text-sm">{translations[langMode].org}<span className="text-[#FF9F29]">*</span></label>
                          <ReactSelector
                            options={Array.isArray(organization) ? (organization || [])?.map((item) => ({ "value": item.organizationId, "label": item.organizationName })) : []}
                            defaultValue={formattedOrganization}
                            onChange={(e) => {
                              formik.setFieldValue("organization", e?.value);
                            }}
                          />
                        </div>
                        <div className="flex flex-col gap-2">
                          <label className="text-sm">{translations[langMode].department} <span className="text-[#FF9F29]">*</span></label>
                          <ReactSelector
                            defaultValue={formattedDepartment}
                            options={[
                              ...(formik?.values?.userType === "admin" || formik?.values?.userType === "office_user"
                                ? [{ value: "all", label: "All" }]
                                : []),
                              ...(department || [])?.map((item) => ({
                                value: item.id,
                                label: item.name,
                                disabled: formik?.values?.departmentList.length === (department || [])?.length ? true : false
                              })),
                            ]}
                            onChange={(e) => {
                              if (e?.value === 'all') {
                                formik.setFieldValue('departmentList', []);
                              } else if (Array.isArray(e)) {
                                const selectedIds = e.map((option) => option.value);
                                formik.setFieldValue("departmentList", selectedIds?.includes("all") ? (department || [])?.map(i => i?.id) : selectedIds);
                              } else {
                                formik.setFieldValue('departmentList', [e?.value]);
                              }
                            }}
                            height={(formik?.values?.departmentList.length > 1) ? (formik?.values?.departmentList.length) * "27px" : "46px"}
                            isMulti={formik?.values?.userType === "admin" || formik?.values?.userType === "office_user" ? true : false}
                            isClearable={false}
                            isOptionDisabled={(option) => option.disabled}
                          />
                        </div>
                        <div className="flex flex-col gap-2">
                          <label className="text-sm">{translations[langMode].project} <span className="text-[#FF9F29]">*</span></label>
                          <ReactSelector
                            defaultValue={formattedProject}
                            options={[
                              { value: "all", label: "All" }, // Only add if condition is true
                              ...(Object.values(project)?.flat() || []).map((item) => ({
                                value: item.id,
                                label: item.name,
                                disabled: formik?.values?.projectList.length === (Object.values(project)?.flat() || [])?.length ? true : false
                              })),
                            ]}
                            onChange={(e) => {
                              if (e?.value === 'all') {
                                formik.setFieldValue("projectList", []); // Set to empty array when "All" is selected
                              } else if (Array.isArray(e)) {
                                const selectedIds = e.map((option) => option.value);
                                formik.setFieldValue("projectList", selectedIds?.includes("all") ? (Object.values(project)?.flat() || [])?.map(i => i?.id) : selectedIds);
                              } else {
                                formik.setFieldValue('projectList', [e?.value]);
                              }
                            }}
                            isClearable={false}
                            isOptionDisabled={(option) => option.disabled}
                            isMulti={true}
                            height={(formik?.values?.projectList.length > 1) ? (formik?.values?.projectList.length) * "27px" : "46px"}
                          />
                        </div>
                        <div className={`${!isClock ? "hidden" : ""} flex flex-col gap-2`}>
                          <label className="text-sm">Clock In<span className="text-[#FF9F29]">*</span></label>
                          <ReactSelector
                            defaultValue={formattedClockIn}
                            options={(clockIn || [])?.filter(Boolean)?.map((item) => ({ value: item.id, label: item.name }))}
                            onChange={(e) => {
                              formik.setFieldValue("projectIdForClockInClockOut", e?.value);
                            }}
                          />
                        </div>

                        <div className={`${formik?.values?.userType !== "field_agent" ? "hidden" : ""} flex flex-col gap-2`}>
                          <label className="text-sm">Activity<span className="text-[#FF9F29]">*</span></label>
                          <ReactSelector
                            defaultValue={formattedActivity}
                            options={[
                              ...(formik?.values?.userType !== "admin" || formik?.values?.userType !== "office_user"
                                ? [{ value: "all", label: "All" }]
                                : []),
                              ...(workflowList || [])?.map((item) => ({
                                "value": item?.workflowId,
                                "label": item?.workflowName,
                                disabled: formik?.values?.workflowList.length === workflowList?.length ? true : false
                              }))
                            ]}
                            onChange={(e) => {
                              if (e?.value === 'all') {
                                formik.setFieldValue("workflowList", []); // Set to empty array when "All" is selected
                              } else if (Array.isArray(e)) {
                                const selectedIds = e.map((option) => option.value);
                                formik.setFieldValue("workflowList", selectedIds?.includes("all") ? (workflowList || [])?.map(i => i?.workflowId) : selectedIds);
                              } else {
                                formik.setFieldValue("workflowList", e?.map((item) => item?.value));
                              }
                            }}
                            // isDisabled={formik?.values?.userType === "admin" || formik?.values?.userType === "office_user"}
                            isOptionDisabled={(option) => option.disabled}
                            isMulti={formik?.values?.userType === "admin" || formik?.values?.userType === "office_user" ? false : true}
                            height={(formik?.values?.workflowList.length > 1) ? (formik?.values?.workflowList.length) * "27px" : "46px"}
                          />
                        </div>
                        <div className=" relative flex flex-col gap-2 h-[76px]">
                          <label className="text-sm">{translations[langMode].password} <span className="text-[#FF9F29]">*</span></label>
                          <input
                            type={showPassword ? "text" : "password"}
                            name="password"
                            defaultValue={userId ? "" : formik.values.password}
                            onChange={(e) => {
                              const newValue = e.target.value;
                              formik.setFieldValue("password", newValue);
                              if (userId && newValue) {
                                setIsPasswordCleared(true)
                              }
                            }}
                            className={`block p-3 w-full text-sm text-gray-900 bg-transparent rounded-md border-1 border-[#D1D5DB]
                  appearance-none focus:outline-none focus:ring-0 focus:border-gray-500 peer ${theme === "dark" ? "dark-mode" : theme === "high-contrast" ? "high-contrast" : ""
                              }`}
                          />
                          <button
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                            className="absolute text-sm text-gray-400 top-[58%] right-3.5"
                          >
                            {showPassword ? <FaEye /> : <FaEyeSlash />}
                          </button>

                          {formik.touched.password && formik.errors.password && (
                            <div className="text-red-500 text-xs">{formik.errors.password}</div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div className="">
                  {formik?.values?.userType !== "field_agent" && <span
                    className="text-lg text-[#236DB4] font-bold underline cursor-pointer font-[sans-serif]"
                    onClick={() => setIsShowPrivileges(true)}>
                    <p className="">{translations[langMode].editPrivileges}</p>
                  </span>}
                  <div className="mb-0">
                    <div className="pt-[39px] flex justify-center gap-[16px] items-center">
                      <button
                        type="button"
                        onClick={handleGoBack}
                        className="py-3 px-[14px] w-full max-w-[150px] me-2 mb-2 text-sm font-medium text-[#236DB4] focus:outline-none bg-white rounded-lg border border-[#236DB4] focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600"
                      >
                        {translations[langMode].cancel}
                      </button>
                      <button
                        type="submit"
                        className={`py-3 px-[14px] w-full max-w-[150px] text-white bg-[#236DB4] font-medium rounded-lg text-sm me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800 ${isLoader ? "bg-opacity-60" : "bg-opacity-100"}`}
                      >
                        {isLoader ? "Saving...": translations[langMode].save}
                      </button>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            </form>
          </div>

        </div>
      </div>
      <Transition.Root show={isShowPrivileges} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          onClose={() => setIsShowPrivileges(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity z-50" />
          </Transition.Child>
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={`absolute transform rounded-lg shadow-xl bg-white flex flex-col gap-[33px] !max-w-[592px] !w-full h-auto !top-[7%] py-[21px] px-[24px] max-h-[75vh] h-full overflow-y-auto`} >

                <div className={`flex  justify-between`}>
                  <p className="font-bold text-base">{translations[langMode].editPrivileges}</p>
                  <button
                    type="button"
                    className="text-gray-600 transition-transform transform hover:scale-110"
                    onClick={() => setIsShowPrivileges(false)}
                  >
                    <RxCross2 className="h-6 w-6" />
                  </button>
                </div>
                <div className="flex flex-col gap-[24px]">
                  {
                    (privileges || [])?.map((item) => (
                      <div className="flex justify-between" key={item.key} >
                        <p className="text-sm font-semibold">{item.label}</p>
                        <label className='flex cursor-pointer select-none items-center gap-[12px]' htmlFor={item.key}>
                          <p className="text-sm font-semibold">Status</p>
                          <div className='relative'>
                            <input
                              type='checkbox'
                              id={item.key}
                              checked={privilegeStatus[item.key]}
                              onChange={() => handleCheckboxChangeValue(item.key)}
                              className='sr-only'
                            />
                            <div className={`block h-[18px] w-[36px] rounded-full ${privilegeStatus[item.key] ? "bg-[#236DB4] border border-[#236DB4]" : "bg-[#CBE9FF]"} `}></div>
                            <div
                              className={`dot absolute left-[1.25px] top-[1.45px] h-[15px] w-[16px] rounded-full transition-transform ${privilegeStatus[item.key] ? "translate-x-4 bg-[#FFF]" : "translate-x-0 bg-[#D9D9D9]"
                                }`}
                            ></div>
                          </div>
                        </label>
                      </div>
                    ))
                  }
                  <div className="flex justify-between">
                    <p className="text-sm font-semibold">{translations[langMode].uservisibility}</p>
                    <ReactSelector
                      defaultValue={userVisibility.length > 1
                        ? [{ label: "Office User", value: "office_user" }, { label: "Field User", value: "field_agent" }].filter(item => userVisibility.includes(item.value))
                        : [{ label: "Office User", value: "office_user" }, { label: "Field User", value: "field_agent" }].find(item => userVisibility.includes(item.value))}
                      options={([{ label: "Office User", value: "office_user" }, { label: "Field User", value: "field_agent" }] || [])?.map((item) => ({ "value": item.value, "label": item.label }))}
                      onChange={handleVisibilityChange}
                      isMulti
                      isClearable={false}
                      height="32px !important"
                    />
                  </div>
                </div>
                {/* <div className="flex gap-[10px] w-full justify-center">
                  <button className="bg-[#236DB4] font-bold text-xs max-w-[64px] w-full max-h-[35px] h-full flex justify-center items-center text-white rounded-[4px] p-[10px]"
                  onClick={() => setIsShowPrivileges(false)}
                  >Save</button>
                  <button
                  type="button"
                  className="max-w-[64px] font-bold text-xs w-full max-h-[35px] h-full flex justify-center items-center border border-[#236DB4] text-[#236DB4] rounded-[4px] p-[10px]"
                  onClick={() => setIsShowPrivileges(false)}>{translations[langMode].cancel}</button>
                </div> */}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};

export default AddUser;
